module.exports = __webpack_public_path__ + "media/application/images/icons/phone-7eb54d8a6fcf18b47a3938170a08d657.svg";